// extracted by mini-css-extract-plugin
module.exports = {"button":"LoginButton_button__1APvL"};